import * as React from "react";
import {useEffect} from "react";
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import api from "../../../utils/api";
import reservationStore from "../../../store/reservationStore";
import {getDayOfWeek} from "../../../utils/util";
import CircleIcon from '@mui/icons-material/Circle';


const hospitalParam = {
  cusId: '',
  famId: '',
  hosId: ''
}

const SetPay = () => {
  const storeData: any = reservationStore();
  const [selectHospital, setSelectHospital] = React.useState({
    name: '', address: '', buildingNum: '', phone: '', notice: '', plusInfo: '', fileName: ''
  });
  const [showB2b, setShowB2b] = React.useState(false);
  const [basicPrice, setBasicPrice] = React.useState(0);
  const [inspectionPrice, setInspectionPrice] = React.useState(0);
  const [groudPrice, setGroudPrice] = React.useState(0);
  const [servicePrice, setServicePrice] = React.useState(0);

  const companyObj = JSON.parse(localStorage.getItem("companyInfo") || '');

  useEffect(() => {
    window.scrollTo(0, 0);
    let familyInfo = JSON.parse(localStorage.getItem("FAM_INFO") || '');
    let companyInfo = JSON.parse((localStorage.getItem('companyInfo') || ''));
    hospitalParam.cusId = decodeURIComponent(localStorage.getItem("userCusID") || '');
    hospitalParam.famId = decodeURIComponent(storeData.reservationInfo.famId);
    hospitalParam.hosId = decodeURIComponent(storeData.reservationInfo.hosId);

    // 선택한 병원 정보
    api.post('customer/api/v1/CU_003_003_2', hospitalParam).then(res => {
      localStorage.setItem('HOS_INFO', JSON.stringify(res.data));
      setSelectHospital(res.data);
    }).catch(function (error) {
      console.log(error)
    });

    // 선택한 패키지 정보
    api.get(`customer/api/v2/customers/${encodeURIComponent(hospitalParam.cusId)}/packages/${encodeURIComponent(storeData.reservationInfo.pkgId)}/more?family_id=${encodeURIComponent(hospitalParam.famId)}`).then(res => {
      storeData.setPakageInfoResult(res.data.data.result);
      storeData.setPakageInfoPiis(res.data.data.piis);

      // 결제 화면에서 비용 계산
      const supportPercent = parseInt(familyInfo.supportPercent);
      const supportPrice = parseInt(familyInfo.supportPrice);
      const isB2B2C = supportPercent < 0;
      const isB2C = String(companyInfo['type']).toUpperCase() === 'B2C';
      const isRebateDirectly = String(companyInfo['is_rebate_directly']).toLowerCase() === 'true';
      const isRebateCounsel = String(companyInfo['is_rebate_counsel']).toLowerCase() === 'true';
      const counselrebatePrice = companyInfo.counsel_rebate_price;
      const isPayment = isRebateCounsel && ( counselrebatePrice > 0 );
      let price = storeData.reservationInfo.addPrice;
      !isB2C ? setShowB2b(true) : setShowB2b(false);

      if (isB2C || isB2B2C) {
        setBasicPrice(counselrebatePrice);
        price += res.data.data.result.price;
      } else {
        setBasicPrice(counselrebatePrice);
        price += res.data.data.result.price - supportPrice + companyInfo.counselrebatePrice;
        price = price >= 0 ? price : 0;
      }
      
      setInspectionPrice(price);

      if (isPayment) {
        setServicePrice(companyInfo.counsel_rebate_price);
        // price -= Number(companyInfo.rebate_price);
      }
      price = price > 0 ? price : 0;
      setGroudPrice(price);
      storeData.setReservationInfo('groudPrice', price);
    }).catch(function (error) {
      console.log(error)
    });

    return () => {
    }
  }, []);



  return (
    <Container maxWidth="sm" sx={{ p: 0, minWidth: 400, }}>
      <Card sx={{ minWidth: 400, bgcolor: '#FFFBF8', pb: 5, mt: 2 }}>

        <Typography sx={{ display: 'block', fontSize: '18px', color: '#666', p: '30px 0 0 0', fontWeight: 700, textAlign: 'center', whiteSpace: 'pre-wrap', }}>
          {
            companyObj && companyObj.company_id == 'DUALHEALTH'
              ? '예약정보를 확인하고\n예약금을 결제해 주세요.'
              : `예약정보를 확인하세요.`
          }
        </Typography>

        <CardContent sx={{ m: '30px auto 0 auto', bgcolor: '#fff', width: 400, boxShadow: '0 -4px 5px rgba(0,0,0,.2)', p: 1, boxSizing: 'border-box' }}>
          <Box sx={{ width: '100%', mt: 2 }}>
            <Typography color={'#666'} fontWeight={700} fontSize={20} align="center" sx={{ mt: 2 }}>
              {selectHospital['name']}
            </Typography>
            <Typography color={'#666'} fontWeight={700} fontSize={18} align="center" sx={{ mt: 1 }}>
              {storeData.reservationInfo.date.replaceAll('-', '.') + '.(' + getDayOfWeek(storeData.reservationInfo.date) + ')'}
              {` ${String(storeData.reservationInfo.time).slice(0, -2)}:${String(storeData.reservationInfo.time).slice(-2)}`}
              {/*(월)*/}
            </Typography>
            <Divider sx={{ mt: 2 }} />
            <Divider sx={{ mt: .5 }} />
          </Box>

          <Box sx={payBoxStyle} >
            <List sx={payListStyle}>
              <ListItem>
                병원
              </ListItem>
              <ListItem>
                패키지
              </ListItem>
              <ListItem>
                기본 상담 비용
              </ListItem>
              <ListItem>
                추가 상담 비용
              </ListItem>
            </List>
            <List sx={payStyle} className="pay">
              <ListItem>
                {selectHospital['name']}
              </ListItem>
              <ListItem>
                {storeData.pakageInfo['result']['name']}
              </ListItem>
              <ListItem>
                {basicPrice.toLocaleString('ko-KR')}원
              </ListItem>
              <ListItem>
                {storeData.reservationInfo.addPrice.toLocaleString('ko-KR')}원
              </ListItem>
            </List>
          </Box>

          <Divider component="div" sx={{ mt: 2 }} />

          <Box sx={payBoxStyle}>
            <List sx={payListStyle}>
              <ListItem>
                총 상담 비용
              </ListItem>
            </List>
            <List sx={payStyle} className="pay">
              <ListItem>
                {inspectionPrice.toLocaleString('ko-KR')}원
              </ListItem>
            </List>
          </Box>

          {/*<Divider component="div" sx={{ mt: 2 }} />*/}
          
          {/*<Box sx={payBoxStyle}>*/}
          {/*  <List sx={payListStyle}>*/}
          {/*    <ListItem>*/}
          {/*      현장 결제비용*/}
          {/*    </ListItem>*/}
          {/*    <ListItem>*/}
          {/*      예약보증금*/}
          {/*    </ListItem>*/}
          
          {/*  </List>*/}
          {/*  <List sx={payStyle} className="pay">*/}
          {/*    <ListItem>*/}
          {/*      {groudPrice.toLocaleString('ko-KR')}원*/}
          {/*    </ListItem>*/}
          {/*    <ListItem sx={{ textAlign: 'right', color: '#56bd4a' }}>*/}
          {/*      {servicePrice.toLocaleString('ko-KR')}원*/}
          {/*    </ListItem>*/}
          
          {/*  </List>*/}
          {/*</Box>*/}

          <Divider component="div" sx={{ mt: 2 }} />
          <Divider sx={{ mt: .5 }} />

          <Box sx={{ width: '100%', mt: 2 }}>
            <Typography variant="body1" color="#333" align="center" fontWeight={700} fontSize={16} sx={{ mb: 1 }}>
              결제 금액   <Typography component={'span'} fontSize={12}>(VAT 포함)</Typography>
            </Typography>

            <Typography variant="body1" color="#56bd4a" fontWeight={700} fontSize={20} align="center" sx={{ mb: 2 }}>
              {servicePrice.toLocaleString('ko-KR')}원
            </Typography>

          </Box>

          <Divider component="div" sx={{ mt: 2 }} />
          <Divider sx={{ mt: .5 }} />

          <Box sx={{ width: '100%', mt: 2, pb: 5 }}>
            {
              companyObj && companyObj.company_id == 'DUALHEALTH'
                ? <Typography variant="body1" color="#0d6703" align="center" fontWeight={500} fontSize={14} >
                  병원예약 확인 선결제 금액만 현재 결제됩니다. <br />
                  나머지 차액은 병원에서 현장결제로 이뤄집니다.
                </Typography>
                : null
            }
          </Box>

        </CardContent>
        <Stack direction={'row'} justifyContent={'center'} spacing={0} sx={{ m: '0 auto', width: 320, mt: '0px' }}>
          <CircleIcon sx={bottomCircle} />
          <CircleIcon sx={topCircle} />
          <CircleIcon sx={bottomCircle} />
          <CircleIcon sx={topCircle} />
          <CircleIcon sx={bottomCircle} />
          <CircleIcon sx={topCircle} />
          <CircleIcon sx={bottomCircle} />
          <CircleIcon sx={topCircle} />
          <CircleIcon sx={bottomCircle} />
          <CircleIcon sx={topCircle} />
          <CircleIcon sx={bottomCircle} />
          <CircleIcon sx={topCircle} />
          <CircleIcon sx={bottomCircle} />
          <CircleIcon sx={topCircle} />
          <CircleIcon sx={bottomCircle} />
          <CircleIcon sx={topCircle} />
          <CircleIcon sx={bottomCircle} />
          <CircleIcon sx={topCircle} />
          <CircleIcon sx={bottomCircle} />
          <CircleIcon sx={topCircle} />
          <CircleIcon sx={bottomCircle} />
          <CircleIcon sx={topCircle} />
          <CircleIcon sx={bottomCircle} />
          <CircleIcon sx={topCircle} />
          <CircleIcon sx={bottomCircle} />
          <CircleIcon sx={topCircle} />
          <CircleIcon sx={bottomCircle} />
          <CircleIcon sx={topCircle} />
          <CircleIcon sx={bottomCircle} />
        </Stack>

      </Card>
    </Container>
  );
}

const payBoxStyle = {
  p: 0,
  width: '100%',
  display: 'flex',
  margin: '10px 0',
};

const payListStyle = {
  p: 0,
  width: '60%',
  fontSize: 14,
};

const payStyle = {
  p: 0,
  width: '100%',
  fontSize: 14,
  fontWeight: 700,
  '& li': { justifyContent: 'flex-end' }

};


const topCircle = {
  color: '#fff',
  boxShadow: '0 4px 2px rgba(0,0,0,.2)',
  borderRadius: '50%',
  mt: '-18px',
  fontSize: 14
}

const bottomCircle = {
  color: '#fffbf8',
  boxShadow: '0 -4px 2px rgba(0,0,0,.2)',
  borderRadius: '50%',
  mt: '-10px',
  fontSize: 14
}



export default SetPay;